/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attr_CbdInputs */

const en_attr_cbd = /** @type {(inputs: Attr_CbdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CBD`)
};

const th_attr_cbd = /** @type {(inputs: Attr_CbdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CBD`)
};

const ja_attr_cbd = /** @type {(inputs: Attr_CbdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CBD`)
};

const fr_attr_cbd = /** @type {(inputs: Attr_CbdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CBD`)
};

const es_attr_cbd = /** @type {(inputs: Attr_CbdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CBD`)
};

const ru_attr_cbd = /** @type {(inputs: Attr_CbdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CBD`)
};

const zh_attr_cbd = /** @type {(inputs: Attr_CbdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CBD`)
};

const vi_attr_cbd = /** @type {(inputs: Attr_CbdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CBD`)
};

/**
* | output |
* | --- |
* | "CBD" |
*
* @param {Attr_CbdInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const attr_cbd = /** @type {((inputs?: Attr_CbdInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attr_CbdInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_attr_cbd(inputs)
	if (locale === "ja") return ja_attr_cbd(inputs)
	if (locale === "fr") return fr_attr_cbd(inputs)
	if (locale === "es") return es_attr_cbd(inputs)
	if (locale === "ru") return ru_attr_cbd(inputs)
	if (locale === "zh") return zh_attr_cbd(inputs)
	if (locale === "vi") return vi_attr_cbd(inputs)
	return en_attr_cbd(inputs)
});